import { render, staticRenderFns } from "./MedialBlocks.vue?vue&type=template&id=5543d4f5&scoped=true"
import script from "./MedialBlocks.vue?vue&type=script&lang=js"
export * from "./MedialBlocks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5543d4f5",
  null
  
)

export default component.exports